import React, { useState, useEffect } from 'react';
import api from '../api';

function Settings() {
  const [userInfo,    setUserInfo]    = useState(null);
  const [shopName,    setShopName]    = useState('');
  const [shopAddress, setShopAddress] = useState('');
  const [shopPhone,   setShopPhone]   = useState('');
  const [shopGstin,   setShopGstin]   = useState('');
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPass, setConfirmPass] = useState('');
  const [message,     setMessage]     = useState('');
  const [error,       setError]       = useState('');
  const [loading,     setLoading]     = useState(false);
  const [isPremium,   setIsPremium]   = useState(false);
  const [activeTab,   setActiveTab]   = useState('profile');

  useEffect(() => {
    api.get('/auth/me').then(r => {
      const d = r.data;
      setUserInfo(d);
      setShopName(d.shop_name    || '');
      setShopAddress(d.shop_address || '');
      setShopPhone(d.shop_phone  || '');
      setShopGstin(d.shop_gstin  || '');
      const plan = d.account_type || 'pro';
      setIsPremium(plan === 'premium' || plan === 'business');
    }).catch(() => {});
  }, []);

  const showMsg = (msg, isError = false) => {
    if (isError) setError(msg);
    else setMessage(msg);
    setTimeout(() => { setMessage(''); setError(''); }, 3000);
  };

  const saveProfile = async () => {
    setLoading(true);
    try {
      await api.put('/auth/profile', null, {
        params: {
          shop_name:    shopName,
          shop_address: shopAddress,
          shop_phone:   shopPhone,
          shop_gstin:   shopGstin,
        }
      });
      showMsg('✅ Profile saved! Bill-ல் reflect ஆகும்!');
    } catch (err) {
      showMsg(err.response?.data?.detail || 'Error!', true);
    } finally {
      setLoading(false);
    }
  };

  const changePassword = async () => {
    if (!oldPassword || !newPassword) {
      showMsg('எல்லா fields-ம் fill பண்ணுங்கள்!', true); return;
    }
    if (newPassword.length < 6) {
      showMsg('Password minimum 6 characters!', true); return;
    }
    if (newPassword !== confirmPass) {
      showMsg('New passwords match ஆகவில்லை!', true); return;
    }
    setLoading(true);
    try {
      await api.post('/auth/change-password', {
        current_password: oldPassword,
        new_password:     newPassword,
      });
      showMsg('✅ Password changed!');
      setOldPassword(''); setNewPassword(''); setConfirmPass('');
    } catch (err) {
      showMsg(err.response?.data?.detail || 'Error!', true);
    } finally {
      setLoading(false);
    }
  };

  const planColor = {
    trial: '#888', pro: '#3498DB',
    premium: '#C9A84C', business: '#9B59B6',
  }[userInfo?.account_type || 'pro'] || '#3498DB';

  return (
    <div style={S.page}>
      <h1 style={S.title}>⚙️ Settings</h1>

      {/* Plan Banner */}
      {userInfo && (
        <div style={{...S.planBanner, borderColor: planColor}}>
          <div style={S.planLeft}>
            <span style={{fontSize:'22px'}}>
              {userInfo.account_type === 'premium' ? '👑' :
               userInfo.account_type === 'business' ? '🏢' :
               userInfo.account_type === 'trial'   ? '🆓' : '⭐'}
            </span>
            <div>
              <div style={S.planName}>{userInfo.plan_name || 'Pro Plan'}</div>
              <div style={S.planSub}>
                {userInfo.is_paid
                  ? `Rs.${userInfo.monthly_price || 299}/month`
                  : `Trial: ${userInfo.days_left} days left`}
              </div>
            </div>
          </div>
          {!isPremium && (
            <button
              style={S.upgradeSmallBtn}
              onClick={() => window.location.href = '/trial-expired'}>
              👑 Upgrade
            </button>
          )}
        </div>
      )}

      {/* Tabs */}
      <div style={S.tabs}>
        <button
          style={{...S.tab, ...(activeTab==='profile'  ? S.tabActive : {})}}
          onClick={() => setActiveTab('profile')}>
          🏪 Shop Profile
        </button>
        <button
          style={{...S.tab, ...(activeTab==='password' ? S.tabActive : {})}}
          onClick={() => setActiveTab('password')}>
          🔑 Password
        </button>
        <button
          style={{...S.tab, ...(activeTab==='plan'     ? S.tabActive : {})}}
          onClick={() => setActiveTab('plan')}>
          💳 My Plan
        </button>
      </div>

      {/* Messages */}
      {message && <div style={S.successBox}>{message}</div>}
      {error   && <div style={S.errorBox}>{error}</div>}

      {/* ── PROFILE TAB ── */}
      {activeTab === 'profile' && (
        <div style={S.section}>
          <h3 style={S.sectionTitle}>🏪 Shop Details</h3>
          <p style={S.sectionNote}>
            Bill print-ல் இந்த details show ஆகும்!
          </p>

          <label style={S.label}>Shop Name *</label>
          <input style={S.input}
            placeholder="உங்கள் கடை பெயர்"
            value={shopName}
            onChange={e => setShopName(e.target.value)}/>

          {/* Premium only fields */}
          <div style={{
            ...S.premiumBox,
            opacity: isPremium ? 1 : 0.6,
          }}>
            <div style={S.premiumTitle}>
              👑 Premium Bill Fields
              {!isPremium && (
                <span style={{color:'#E74C3C',fontSize:'11px',marginLeft:'8px'}}>
                  (Upgrade to unlock!)
                </span>
              )}
            </div>

            <label style={S.label}>Shop Address</label>
            <input style={S.input}
              placeholder="கடை address (Premium bill header-ல் show ஆகும்!)"
              value={shopAddress}
              onChange={e => setShopAddress(e.target.value)}
              disabled={!isPremium}/>

            <label style={S.label}>Shop Phone</label>
            <input style={S.input}
              placeholder="கடை phone number"
              type="tel"
              value={shopPhone}
              onChange={e => setShopPhone(e.target.value)}
              disabled={!isPremium}/>

            <label style={S.label}>GST Number (GSTIN)</label>
            <input style={S.input}
              placeholder="33XXXXX... (bill GST header!)"
              value={shopGstin}
              onChange={e => setShopGstin(e.target.value.toUpperCase())}
              disabled={!isPremium}/>

            {!isPremium && (
              <div style={S.premiumHint}>
                ⬆️ Premium plan (Rs.599/month)-ல் இந்த details
                Kumar Super Market style bill-ல் show ஆகும்!
                <br/>Address + Phone + GST = Professional bill! ✅
                <br/>
                <button
                  style={S.upgradeHintBtn}
                  onClick={() => window.location.href = '/trial-expired'}>
                  👑 Premium-க்கு Upgrade பண்ணுங்கள்!
                </button>
              </div>
            )}
          </div>

          <button
            style={{...S.saveBtn, opacity: loading ? 0.6 : 1}}
            onClick={saveProfile}
            disabled={loading}>
            {loading ? '⏳ Saving...' : '💾 Save Profile'}
          </button>
        </div>
      )}

      {/* ── PASSWORD TAB ── */}
      {activeTab === 'password' && (
        <div style={S.section}>
          <h3 style={S.sectionTitle}>🔑 Change Password</h3>

          <label style={S.label}>Current Password</label>
          <input style={S.input}
            placeholder="பழைய password"
            type="password"
            value={oldPassword}
            onChange={e => setOldPassword(e.target.value)}/>

          <label style={S.label}>New Password</label>
          <input style={S.input}
            placeholder="புது password (minimum 6 characters)"
            type="password"
            value={newPassword}
            onChange={e => setNewPassword(e.target.value)}/>

          <label style={S.label}>Confirm New Password</label>
          <input style={S.input}
            placeholder="புது password மீண்டும் type பண்ணுங்கள்"
            type="password"
            value={confirmPass}
            onChange={e => setConfirmPass(e.target.value)}/>

          {newPassword && confirmPass && newPassword !== confirmPass && (
            <p style={{color:'#E74C3C',fontSize:'12px',margin:'4px 0'}}>
              ❌ Passwords match ஆகவில்லை!
            </p>
          )}
          {newPassword && confirmPass && newPassword === confirmPass && (
            <p style={{color:'#27AE60',fontSize:'12px',margin:'4px 0'}}>
              ✅ Passwords match!
            </p>
          )}

          <button
            style={{...S.saveBtn, opacity: loading ? 0.6 : 1}}
            onClick={changePassword}
            disabled={loading}>
            {loading ? '⏳ Changing...' : '🔑 Change Password'}
          </button>
        </div>
      )}

      {/* ── PLAN TAB ── */}
      {activeTab === 'plan' && userInfo && (
        <div style={S.section}>
          <h3 style={S.sectionTitle}>💳 My Plan Details</h3>

          {/* Plan comparison */}
          <div style={S.planGrid}>
            {[
              {id:'pro',     name:'⭐ Pro',     price:299, users:1, items:'1,000'},
              {id:'premium', name:'👑 Premium', price:599, users:3, items:'3,000'},
              {id:'business',name:'🏢 Business',price:999, users:5, items:'10,000'},
            ].map(p => (
              <div key={p.id} style={{
                ...S.planCompCard,
                border: userInfo.account_type===p.id
                  ? '2px solid #C9A84C' : '1px solid #EEE',
                background: userInfo.account_type===p.id
                  ? '#FFF9E6' : 'white',
              }}>
                <div style={{fontWeight:'700',fontSize:'13px',marginBottom:'4px'}}>
                  {p.name}
                </div>
                <div style={{fontSize:'20px',fontWeight:'900',color:'#2C3E50'}}>
                  Rs.{p.price}
                </div>
                <div style={{fontSize:'10px',color:'#888',margin:'2px 0 6px'}}>
                  /month
                </div>
                <div style={{fontSize:'11px',color:'#555'}}>
                  {p.users} User{p.users>1?'s':''}<br/>
                  {p.items} Items
                </div>
                {userInfo.account_type === p.id && (
                  <div style={S.currentBadge}>✅ Current</div>
                )}
              </div>
            ))}
          </div>

          {/* Account info */}
          <div style={S.infoTable}>
            {[
              ['Name',   userInfo.name],
              ['Email',  userInfo.email],
              ['Phone',  userInfo.phone || '—'],
              ['Shop',   userInfo.shop_name],
              ['Plan',   userInfo.plan_name || 'Pro'],
              ['Price',  `Rs.${userInfo.monthly_price || 299}/month`],
              ['Status', userInfo.is_paid
                ? '✅ Active'
                : `⏳ Trial (${userInfo.days_left} days left)`],
            ].map(([label, val]) => (
              <div key={label} style={S.infoRow}>
                <span style={S.infoLabel}>{label}</span>
                <strong style={S.infoVal}>{val}</strong>
              </div>
            ))}
          </div>

          {userInfo.account_type !== 'business' && (
            <button
              style={S.upgradeBtn}
              onClick={() => window.location.href = '/trial-expired'}>
              🚀 Upgrade Plan
            </button>
          )}
        </div>
      )}
    </div>
  );
}

const S = {
  page:         {padding:'20px',maxWidth:'680px',margin:'0 auto'},
  title:        {color:'#2C3E50',marginBottom:'16px'},
  planBanner: {
    display:'flex',justifyContent:'space-between',alignItems:'center',
    background:'#F8F9FA',border:'2px solid',borderRadius:'12px',
    padding:'12px 16px',marginBottom:'20px',
  },
  planLeft:     {display:'flex',alignItems:'center',gap:'12px'},
  planName:     {fontWeight:'700',color:'#2C3E50',fontSize:'14px'},
  planSub:      {fontSize:'12px',color:'#888'},
  upgradeSmallBtn: {
    background:'#C9A84C',color:'#2C3E50',border:'none',
    padding:'7px 16px',borderRadius:'20px',cursor:'pointer',
    fontSize:'12px',fontWeight:'700',
  },
  tabs:    {display:'flex',gap:'8px',marginBottom:'20px',flexWrap:'wrap'},
  tab: {
    padding:'9px 16px',border:'2px solid #DDD',borderRadius:'8px',
    cursor:'pointer',background:'white',fontWeight:'600',
    fontSize:'13px',color:'#666',
  },
  tabActive:    {borderColor:'#2C3E50',background:'#2C3E50',color:'white'},
  section: {
    background:'#F9F9F9',borderRadius:'12px',
    padding:'20px',border:'1px solid #EEE',
  },
  sectionTitle: {color:'#2C3E50',margin:'0 0 4px',fontSize:'16px'},
  sectionNote:  {color:'#888',fontSize:'12px',margin:'0 0 16px'},
  label: {
    display:'block',fontSize:'11px',fontWeight:'700',color:'#666',
    marginBottom:'4px',marginTop:'12px',textTransform:'uppercase',
  },
  input: {
    display:'block',width:'100%',padding:'10px 12px',
    borderRadius:'8px',border:'1px solid #DDD',fontSize:'14px',
    boxSizing:'border-box',background:'white',
  },
  premiumBox: {
    background:'white',borderRadius:'10px',padding:'14px',
    marginTop:'16px',border:'2px dashed #C9A84C',
  },
  premiumTitle: {fontWeight:'700',color:'#C9A84C',fontSize:'13px'},
  premiumHint: {
    background:'#FFF9E6',borderRadius:'8px',padding:'10px 12px',
    marginTop:'10px',fontSize:'12px',color:'#856404',
    border:'1px solid #C9A84C',lineHeight:'1.6',
  },
  upgradeHintBtn: {
    background:'#C9A84C',color:'#2C3E50',border:'none',
    padding:'6px 14px',borderRadius:'6px',cursor:'pointer',
    fontSize:'12px',fontWeight:'700',marginTop:'8px',
  },
  saveBtn: {
    width:'100%',background:'#2C3E50',color:'white',border:'none',
    padding:'13px',borderRadius:'8px',fontSize:'14px',
    fontWeight:'700',cursor:'pointer',marginTop:'20px',
  },
  upgradeBtn: {
    width:'100%',background:'#C9A84C',color:'#2C3E50',border:'none',
    padding:'13px',borderRadius:'8px',fontSize:'14px',
    fontWeight:'700',cursor:'pointer',marginTop:'16px',
  },
  successBox: {
    background:'#E8F8F0',border:'1px solid #27AE60',color:'#27AE60',
    padding:'10px 14px',borderRadius:'8px',marginBottom:'14px',fontWeight:'600',
  },
  errorBox: {
    background:'#FFF0F0',border:'1px solid #E74C3C',color:'#E74C3C',
    padding:'10px 14px',borderRadius:'8px',marginBottom:'14px',
  },
  planGrid: {
    display:'grid',gridTemplateColumns:'repeat(3,1fr)',
    gap:'10px',marginBottom:'16px',
  },
  planCompCard: {
    borderRadius:'10px',padding:'14px',textAlign:'center',
  },
  currentBadge: {
    marginTop:'6px',background:'#C9A84C',color:'#2C3E50',
    borderRadius:'4px',padding:'2px 6px',fontSize:'10px',fontWeight:'700',
  },
  infoTable:  {marginBottom:'14px'},
  infoRow: {
    display:'flex',justifyContent:'space-between',
    padding:'9px 0',borderBottom:'1px solid #F0F0F0',fontSize:'13px',
  },
  infoLabel:  {color:'#888'},
  infoVal:    {color:'#2C3E50'},
};

export default Settings;


